import type { Chart } from 'chart.js'

type Cursor = string | null

const cursorRequests = new WeakMap<Chart, Map<string, Cursor>>()

export function setCursor(chart: Chart, pluginId: string, cursor: Cursor) {
  let map = cursorRequests.get(chart)

  if (!map) {
    map = new Map()
    cursorRequests.set(chart, map)
  }

  map.set(pluginId, cursor)

  // priority rule: first non-null cursor wins (you can reverse if you want)
  const finalCursor =
    Array.from(map.values()).find((c) => c && c !== 'default') ?? 'default'

  chart.canvas.style.cursor = finalCursor
}

export function clearCursor(chart: Chart, pluginId: string) {
  const map = cursorRequests.get(chart)

  if (!map) return

  map.delete(pluginId)

  const finalCursor =
    Array.from(map.values()).find((c) => c && c !== 'default') ?? 'default'

  chart.canvas.style.cursor = finalCursor
}
